import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-m-2 p-my-4" }
const _hoisted_3 = { class: "kn-material-input-label" }
const _hoisted_4 = { class: "table-header p-d-flex" }
const _hoisted_5 = { class: "p-input-icon-left p-mr-3 p-col-12" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_ctx.data)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("label", _hoisted_3, _toDisplayString(_ctx.data.missingTables.length > 0 ? _ctx.$t('metaweb.updatePhysicalModel.newTables') : _ctx.$t('metaweb.updatePhysicalModel.noNewTables')), 1),
          _createVNode(_component_DataTable, {
            value: _ctx.rows,
            class: "p-datatable-sm kn-table",
            selection: _ctx.selectedTables,
            "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedTables = $event)),
            dataKey: "value",
            filters: _ctx.filters,
            "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
            globalFilterFields: _ctx.metawebPhysicalModelUpdateDialogDescriptor.globalFilterFields,
            onRowSelect: _ctx.onTablesSelect,
            onRowUnselect: _ctx.onTablesSelect,
            onRowSelectAll: _ctx.onTablesSelect,
            onRowUnselectAll: _ctx.onTablesSelect
          }, {
            empty: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
            ]),
            header: _withCtx(() => [
              _createVNode("div", _hoisted_4, [
                _createVNode("span", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_InputText, {
                    class: "kn-material-input",
                    modelValue: _ctx.filters['global'].value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
                    placeholder: _ctx.$t('common.search')
                  }, null, 8, ["modelValue", "placeholder"])
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                selectionMode: "multiple",
                style: _ctx.metawebPhysicalModelUpdateDialogDescriptor.selectColumnStyle
              }, null, 8, ["style"]),
              _createVNode(_component_Column, {
                field: "value",
                header: _ctx.data.missingTables.length > 0 ? _ctx.$t('metaweb.updatePhysicalModel.newTables') : _ctx.$t('metaweb.updatePhysicalModel.noNewTables')
              }, null, 8, ["header"])
            ]),
            _: 1
          }, 8, ["value", "selection", "filters", "globalFilterFields", "onRowSelect", "onRowUnselect", "onRowSelectAll", "onRowUnselectAll"])
        ])
      ]))
    : _createCommentVNode("", true)
}